import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Translate } from 'react-redux-i18n';

export interface CurrencyWarningProps {
  currencies: string[];
}

export const CurrencyWarning: React.FC<CurrencyWarningProps> = ({ currencies }) => {
  if (currencies.length <= 1) return null;

  return (
    <div className="franchise-currency-warning">
      <AlertTriangle className="franchise-currency-warning-icon" />
      <div className="franchise-currency-warning-content">
        <strong><Translate value="franchise.hub.currency-warning.title" /></strong>
        <span>
          <Translate value="franchise.hub.currency-warning.message" /> {currencies.join(', ')}
        </span>
      </div>
    </div>
  );
};
